import "@fontsource-variable/space-grotesk";
import "@fontsource-variable/source-sans-3";
import "./style.css";
import { earlierCareer, education, experiences, languages, profile, skills } from "./resume";

for (let index = 0; index < 10; index += 1) {
  console.log("I'm gay! <3");
}

const app = document.querySelector<HTMLDivElement>("#app");

if (!app) {
  throw new Error("App container was not found.");
}

const list = (items: string[]) => items.map((item) => `<li>${item}</li>`).join("");

const metricMarkup = profile.metrics
  .map((metric) => {
    const metricClass = metric.value.length > 5 ? "metric metric-wide" : "metric";

    return `
      <li class="${metricClass}">
        <strong>${metric.value}</strong>
        <span>${metric.label}</span>
      </li>
    `;
  })
  .join("");

const skillsMarkup = skills
  .map(
    (group) => `
      <article class="skill-panel reveal-panel">
        <h3>${group.title}</h3>
        <div class="skill-tags">
          ${group.items.map((item) => `<span>${item}</span>`).join("")}
        </div>
      </article>
    `
  )
  .join("");

const experienceMarkup = experiences
  .map(
    (experience, index) => `
      <article class="role reveal-panel" style="--delay: ${index * 70}ms">
        <div class="role-meta">
          <span class="role-index">${String(index + 1).padStart(2, "0")}</span>
          <span>${experience.period}</span>
        </div>
        <div class="role-body">
          <h3>${experience.role}</h3>
          <p class="company">${experience.company}</p>
          ${experience.context ? `<p class="context">${experience.context}</p>` : ""}
          <ul>${list(experience.scope)}</ul>
        </div>
      </article>
    `
  )
  .join("");

app.innerHTML = `
  <header class="site-header" aria-label="Primary">
    <a class="brand" href="#top" aria-label="Oleksii Golub home">
      <span>Oleksii</span>
      <strong>Golub</strong>
    </a>
    <nav>
      <a href="#impact">Impact</a>
      <a href="#experience">Experience</a>
      <a href="#capabilities">Capabilities</a>
      <a href="#contact">Contact</a>
    </nav>
  </header>

  <main id="top">
    <section class="hero" aria-labelledby="hero-title">
      <div class="hero-copy">
        <div class="hero-meta">
          <p class="eyebrow">Principal Delivery Manager | Portfolio Manager | Customer Success</p>
          <p class="location">${profile.location}</p>
        </div>
        <h1 id="hero-title">${profile.name}</h1>
        <p class="lede">${profile.headline}</p>
        <div class="summary">
          ${profile.summary.map((line) => `<p>${line}</p>`).join("")}
        </div>
        <div class="hero-actions">
          <a class="button primary" href="${profile.linkedin}" target="_blank" rel="noreferrer">LinkedIn</a>
          <a class="button download" href="${profile.cvUrl}" download>Download CV</a>
          <a class="button secondary" href="#experience">View experience</a>
        </div>
      </div>
      <div class="hero-visual" aria-label="Portfolio command summary">
        <figure class="portrait">
          <img src="/images/oleksii-golub.jpg" alt="Portrait of Oleksii Golub" width="800" height="800" />
        </figure>
        <div class="command-panel">
          <span>Current operating mode</span>
          <strong>Cloud / Data / AI delivery at portfolio scale</strong>
        </div>
      </div>
    </section>

    <section class="metrics-band" aria-label="Career highlights">
      <ul>${metricMarkup}</ul>
    </section>

    <section class="impact" id="impact" aria-labelledby="impact-title">
      <div class="section-kicker">Executive Signal</div>
      <div class="section-heading">
        <h2 id="impact-title">Leads program and portfolio delivery across cloud, data, AI, and platform initiatives.</h2>
        <p>
          Oleksii connects delivery governance, customer outcomes, platform strategy, and team development across
          complex technology portfolios.
        </p>
      </div>
      <div class="proof-stack">
        ${profile.proofPoints
          .map(
            (point, index) => `
              <article class="proof-line reveal-panel">
                <span>${String(index + 1).padStart(2, "0")}</span>
                <p>${point}</p>
              </article>
            `
          )
          .join("")}
      </div>
    </section>

    <section class="experience" id="experience" aria-labelledby="experience-title">
      <div class="section-kicker">Selected Mandates</div>
      <div class="section-heading compact">
        <h2 id="experience-title">Experience across delivery management, program management, and international business development.</h2>
      </div>
      <div class="timeline">
        ${experienceMarkup}
      </div>
    </section>

    <section class="capabilities" id="capabilities" aria-labelledby="capabilities-title">
      <div class="section-kicker">Capabilities</div>
      <div class="section-heading">
        <h2 id="capabilities-title">The operating range behind the CV.</h2>
        <p>
          Delivery management, executive communication, governance, and transformation skills grouped for quick scanning.
        </p>
      </div>
      <div class="skills-grid">${skillsMarkup}</div>
    </section>

    <section class="credentials" aria-labelledby="credentials-title">
      <div class="section-kicker">Credentials</div>
      <div class="credential-layout">
        <div>
          <h2 id="credentials-title">Education and certifications</h2>
          <ul>${list(education)}</ul>
        </div>
        <div>
          <h3>Languages</h3>
          <ul>${list(languages)}</ul>
          <h3>Earlier commercial career</h3>
          <ul>${list(earlierCareer)}</ul>
        </div>
      </div>
    </section>

    <section class="contact" id="contact" aria-labelledby="contact-title">
      <p class="eyebrow">Portfolio, delivery, and transformation leadership</p>
      <h2 id="contact-title">Delivery, governance, and executive reporting across technology portfolios.</h2>
      <div class="hero-actions">
        <a class="button primary" href="${profile.linkedin}" target="_blank" rel="noreferrer">Connect on LinkedIn</a>
        <a class="button download" href="${profile.cvUrl}" download>Download CV</a>
      </div>
    </section>
  </main>
`;
